module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "notfound"
    }
  }, [_c('div', {
    staticClass: "notfound"
  }, [_c('div', {
    staticClass: "notfound-404"
  }, [_c('h3', [_vm._v("Oops! Page not found")]), _vm._v(" "), _c('h1', [_c('span', [_vm._v("4")]), _c('span', [_vm._v("0")]), _c('span', [_vm._v("4")])])]), _vm._v(" "), _c('h2', [_vm._v("we are sorry, but the page you requested was not found")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b3fd68f2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageNotFound.vue
// module id = 748
// module chunks = 0